import {Box, Divider, Typography} from '@mui/material';
import {useToggle} from 'common/hooks/useToggle';
import Button from 'components/Button';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import FormikTextField from 'components/inputs/FormikTextField';
import {FormOneTimeCode} from 'components/inputs/specials/FormOneTimeCode';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {IMfaVerifyRequest} from 'types/diplomat/authentication/MfaVerifyRequest';

export type AuthenticatorFormProps = {
   onSubmit: (values: IMfaVerifyRequest, helpers: FormOnSubmitHelpers<IMfaVerifyRequest>) => void;
   onClose: () => void;
   allowBackupCodes?: boolean;
};
export const AuthenticatorForm = ({
   onSubmit,
   onClose,
   allowBackupCodes,
}: AuthenticatorFormProps) => {
   const {t} = useTranslation();

   return (
      <Formik initialValues={{otp: ''} as IMfaVerifyRequest} onSubmit={onSubmit}>
         <Typography variant="body1">
            {t('Enter the 6-digit verification code generated by the authenticator app.')}
         </Typography>
         <FormOneTimeCode autoFocus length={6} name="otp" />
         {/* <Divider /> */}
         {allowBackupCodes && <RecoverySection />}
         <FormFooterButtons cancel={onClose} />
      </Formik>
   );
};

function RecoverySection() {
   const {t} = useTranslation();
   const inputRef = React.useRef<HTMLInputElement>();
   const [recoveryOpened, toggleRecovery] = useToggle();
   const onClick = () => {
      toggleRecovery();
      if (!recoveryOpened) {
         setTimeout(() => {
            inputRef.current?.focus();
         }, 200);
      }
   };

   return (
      <Box marginTop="2rem">
         <Button onClick={onClick}>{t('Click here to enter a recovery code instead')}</Button>
         {recoveryOpened && <FormikTextField inputRef={inputRef} name="recoveryCode" />}
      </Box>
   );
}
